import {listen} from "../utils";

const Selector = {
    NUM_SELECTED: '[data-num-selected]',
    SELECT_ALL: '[data-select-all]',
    SELECTABLE: '[data-selectable]',
    SELECTION_CONTAINER: '.card,tr,li',
    SELECTION_REQUIRED: '[data-selected]',
    HIDE_SELECTED: '[data-hide-selected]',
    CLEAR_SELECTION: '[data-clear-selection]'
}

listen('change', Selector.SELECTABLE, (event, target) => {
    if (target.type === 'radio') {
        target.form?.querySelectorAll(Selector.SELECTION_CONTAINER).forEach((e) => e.classList.remove('active'))
    }
    target.closest(Selector.SELECTION_CONTAINER)?.classList.toggle('active', target.checked)
    if (!target.form?.dataset.selectionField)
        target.form.querySelectorAll(Selector.SELECTION_REQUIRED).forEach((e) => e.disabled = !target.checked)
})

export function storeSelection(forms) {
    forms.forEach((form) => {
        const selectionFieldName = form.dataset.selectionField
        const selectionFieldValues = new Set();
        const numSelected = form.querySelector(Selector.NUM_SELECTED)
        const clearButton = form.querySelector(Selector.CLEAR_SELECTION)
        const inputs = [...form.querySelectorAll(`input[type="checkbox"][name="${selectionFieldName}"]`)]
        const hideSelected = form.querySelectorAll(Selector.HIDE_SELECTED)
        hideSelected.forEach((el) => el.classList.toggle('d-none', selectionFieldValues.size > 0))

        const handleCheck = (inputs) => {
            inputs.forEach((input) => {
                input.closest(Selector.SELECTION_CONTAINER)?.classList.toggle('active', input.checked)
                input.checked ? selectionFieldValues.add(input.value) : selectionFieldValues.delete(input.value)
            })
            if (numSelected) {
                numSelected.textContent = `${selectionFieldValues.size}`
            }
            clearButton.classList.toggle('d-none', selectionFieldValues.size === 0)
            hideSelected.forEach((el) => el.classList.toggle('d-none', selectionFieldValues.size !== 0))
            form.querySelectorAll(Selector.SELECTION_REQUIRED).forEach((el) => el.disabled = selectionFieldValues.size === 0)
        }

        const handleClear = () => {
            form.querySelectorAll(Selector.SELECTION_CONTAINER).forEach((el) => el.classList.remove('active'))
            if (numSelected) {
                numSelected.textContent = '0'
            }
            if (clearButton) {
                clearButton.classList.add('d-none')
                hideSelected.forEach((el) => el.classList.remove('d-none'))
                form.querySelectorAll(Selector.SELECTION_REQUIRED).forEach((el) => el.disabled = true)
                form.querySelectorAll(Selector.SELECT_ALL).forEach((el) => el.checked = false)
                inputs.forEach((el) => el.checked = false)
                selectionFieldValues.clear()
            }
        }

        if (numSelected) {
            numSelected.textContent = `${selectionFieldValues.size}`
        }

        if (clearButton) {
            clearButton.classList.toggle('d-none', selectionFieldValues.size === 0)
            form.querySelectorAll(Selector.SELECTION_REQUIRED).forEach((el) => el.disabled = selectionFieldValues.size === 0)
        }

        inputs.forEach((input) => {
            input.checked = selectionFieldValues.has(input.value.toString())
            input.closest(Selector.SELECTION_CONTAINER)?.classList.toggle('active', input.checked)
            input.addEventListener('change', () => handleCheck([input]))
        });

        form.querySelectorAll(Selector.SELECT_ALL).forEach((button) => {
            button.addEventListener('click', () => {
                inputs.forEach((input) => input.checked = button.checked)
                handleCheck(inputs)
            })
        })

        form.querySelectorAll('button[type="reset"], button[hx-post]').forEach((button) => {
            button.addEventListener('click', () => handleClear())
        })

        listen('click', Selector.CLEAR_SELECTION, () => handleClear())
    })
}
